import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import { Subject } from 'rxjs';
import { PropertyChainParser } from '../property-chain-parser';
import { SuggestionGenerator } from '../suggestion-generator';

function getKeywords(): string[] {
  return [
    'card',
    'card.card_number',
    'card.operation_type',
    'card.request',
    'card.request.patients',
    'card.request.patients.@.weight_in_kg',
    'card.request.patients.@.age',
    'card.request.patients.@.gender',
    'card.request.patients.@.transport_reason',
    'card.request.patients.@.transport_reason.name',
    'card.request.patients.@.chief_complaint_notes',
    'card.request.patients.@.notes',
    'card.request.patients.@.number_of_drips',
    'card.request.patients.@.is_intubated',
    'card.request.patients.@.specialty_equipment',
    'card.request.patients.@.is_ride_along_requested',
    'card.request.patients.@.ride_along_requested_weight',
    'card.request.patients.@.ride_along_date_of_birth',
    'card.request.patients.@.first_name',
    'card.request.patients.@.last_name',
    'card.request.patients.@.date_of_birth',
    'card.request.patients.@.ride_along_name',
    'card.request.pickup_location',
    'card.request.pickup_location.location',
    'card.request.pickup_location.location.abbreviation',
    'card.request.pickup_location.fbo',
    'card.request.pickup_location.fbo.name',
    'card.request.pickup_location.medical_facility',
    'card.request.pickup_location.medical_facility.abbreviation',
    'card.request.pickup_location.medical_facility.name',
    'card.request.pickup_location.room_number',
    'card.request.pickup_location.bed_number',
    'card.request.pickup_location.notes',
    'card.request.pickup_location.address',
    'card.request.pickup_location.address.gps_id',
    'card.request.pickup_location.address.city',
    'card.request.pickup_location.address.region',
    'card.request.pickup_location.address.county',
    'card.request.pickup_location.address.street_address',
    'card.request.pickup_location.readable_dm',
    'card.request.pickup_location.medical_facility_address',
    'card.request.pickup_location.medical_facility_address.street_address',
    'card.request.pickup_location.medical_facility_address.city',
    'card.request.pickup_location.ground_contact',
    'card.request.dropoff_location',
    'card.request.dropoff_location.location',
    'card.request.dropoff_location.location.abbreviation',
    'card.request.dropoff_location.fbo',
    'card.request.dropoff_location.fbo.name',
    'card.request.dropoff_location.medical_facility',
    'card.request.dropoff_location.medical_facility.abbreviation',
    'card.request.dropoff_location.medical_facility.name',
    'card.request.dropoff_location.room_number',
    'card.request.dropoff_location.bed_number',
    'card.request.dropoff_location.notes',
    'card.request.dropoff_location.address',
    'card.request.dropoff_location.address.gps_id',
    'card.request.dropoff_location.address.city',
    'card.request.dropoff_location.address.region',
    'card.request.dropoff_location.address.county',
    'card.request.dropoff_location.un_confirmed',
    'card.request.dropoff_location.medical_facility_address',
    'card.request.dropoff_location.medical_facility_address.street_address',
    'card.request.dropoff_location.medical_facility_address.city',
    'card.request.dropoff_location.readable_dm',
    'card.request.customer_description',
    'card.request.requestor',
    'card.request.requestor.mission_role_type',
    'card.request.safety_questions',
    'card.request.safety_questions.other_service_declined',
    'card.request.safety_questions.other_service_description',
    'card.request.safety_questions.other_services_are_responding_to_transferring',
    'card.request.safety_questions.other_service_response_description',
    'card.request.ground_contact',
    'card.request.requesting_agency',
    'card.request.requesting_agency.name',
    'card.request.web_order_call_type',
    'card.operation',
    'card.operation.unit',
    'card.operation.unit.abbreviation',
    'card.operation.unit.name',
    'card.operation.trip',
    'card.operation.trip.legs',
    'card.operation.trip.legs.@.sequence',
    'card.operation.trip.legs.@.duration_in_minutes',
    'card.operation.trip.legs.@.arriving_odometer_reading',
    'card.operation.trip.legs.@.departing_odometer_reading',
    'card.operation.trip.legs.@.manifest_entries',
    'card.operation.trip.legs.@.manifest_entries.@.title',
    'card.operation.trip.legs.@.manifest_entries.@.name',
    'card.time_unitOffered',
    'card.crew_notified',
    'card.timestamps',
    'card.number',
    'card.operations_type',
    'unit',
    'unit.name',
    'unit.abbreviation',
    'unit.vehicle',
    'unit.vehicle.registration_number',
    'oos_event',
    'oos_event.crew_members',
    'oos_event.crew_members.@.name',
    'oos_event.crew_members.@.role',
    'oos_event.crew_members.@.title',
    'oos_event.crew_members.@.end_date',
    'oos_event.unit',
    'oos_event.unit.abbreviation',
    'oos_event.unit.vehicle',
    'oos_event.unit.vehicle.registration_number',
    'oos_event.unit.name',
    'oos_event.reason',
    'oos_event.reason.name',
    'oos_event.secondary_reason',
    'oos_event.secondary_reason.name',
    'oos_event.event_number',
    'oos_event.type',
    'oos_event.notes',
    'oos_event.human_error_damage_changed',
    'oos_event.far135415_changed',
    'oos_event.far135417_changed',
    'oos_event.assigned_base_name',
    'paip_event',
    'paip_event.id',
    'paip_event.company_id',
    'paip_event.start_time',
    'paip_event.end_time',
    'paip_event.notes',
    'paip_event.reason_id',
    'paip_event.reason',
    'paip_event.reason.id',
    'paip_event.reason.name',
    'paip_event.reason.out_of_service_reason_id',
    'paip_event.reason.out_of_service_reason',
    'paip_event.reason.out_of_service_reason.id',
    'paip_event.reason.out_of_service_reason.name',
    'paip_event.unit_ids',
    'paip_event.unit_ids.@.id',
    'paip_event.cards',
    'paip_event.cards.@.id',
    'paip_event.cards.@.card_number',
    'paip_event.date_created',
    'paip_event.date_last_updated',
    'paip_event.date_deleted',
    'paip_event.last_updated_by_id',
    'timestamp',
    'timestamp.time',
    'reason',
    'reason.name',
    'timestampData',
    'timestampData.note',
    'bearing_in_degrees',
    'distance_in_miles_nautical',
    'duration_in_minutes',
  ];
}

export function monacoLoad() {
  // Create Custom Language
  monaco.languages.register({
    id: 'scriban',
    extensions: [
      '.sbn',
      '.sbn-html',
      '.sbnhtml',
      '.sbn-htm',
      '.sbnhtm',
      '.sbn-txt',
      '.sbntxt',
      '.sbn-cs',
      '.sbncs',
      '.scriban',
      '.scriban-html',
      '.scriban-htm',
      '.scriban-txt',
      '.scriban-cs',
    ],
    mimetypes: ['text/scriban', 'text/sbn'],
  });

  // Configure language
  monaco.languages.setLanguageConfiguration('scriban', {
    brackets: [
      ['{{', '}}'],
      ['{%{', '}%}'],
    ],
    surroundingPairs: [
      { open: '{{', close: '}}' },
      { open: '{%{', close: '}%}' },
    ],
    comments: {
      blockComment: ['{%{', '}%}'],
      lineComment: '#',
    },
    folding: {
      markers: { start: /{{|{%{/, end: /}}|}%}/ },
    },
    wordPattern: /[a-z_$][\w]*/,
    indentationRules: {
      indentNextLinePattern: /{{/,
      decreaseIndentPattern: /}}/,
      increaseIndentPattern: /{{/,
    },
    autoClosingPairs: [
      { open: '{{', close: ' }}' },
      { open: '{{-', close: ' -}}' },
      { open: '{{~', close: ' ~}}' },
      { open: '{%{', close: ' }%}' },
      { open: '(', close: ')' },
    ],
  });

  monaco.languages.setMonarchTokensProvider('scriban', {
    keywords: [...getKeywords()],
    booleans: ['true', 'false'],
    typeKeywords: [
      'if',
      'else',
      'end',
      'func',
      'for',
      'break',
      'continue',
      'in',
      'while',
      'capture',
      'readonly',
      'import',
      'with',
      'wrap',
      'include',
      'ret',
      'case',
      'when',
      'this',
      'empty',
      'tablerow',
      'full_date',
    ],
    operators: ['==', '!=', '>=', '<=', '&&', '||', '??'],

    // we include these common regular expressions
    symbols: /[=><!~?:&|+\-*\/^%]+/,
    escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,

    tokenizer: {
      root: [
        [/{{[~\-]?/, 'brackets', '@scriban'],
        [/{%+{[~\-]?/, 'brackets', '@comment1'],
      ],

      scriban: [
        [/{{[~\-]?/, 'brackets', '@push'],
        [/[~\-]?}}/, 'brackets', '@pop'],

        [
          /[a-z_$][\w$\.]*/,
          {
            cases: {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '@typeKeywords': 'type',
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '@keywords': 'keyword',
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '@booleans': 'keyword',
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '@default': 'variable',
            },
          },
        ],

        // whitespace
        { include: '@whitespace' },

        // delimiters and operators
        [/[{}()\[\]]/, '@brackets'],
        [/[<>](?!@symbols)/, '@brackets'],
        [
          /@symbols/,
          {
            cases: {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '@operators': 'operator',
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '@default': 'identifier',
            },
          },
        ],

        // numbers
        [/\d*\.\d+([eE][\-+]?\d+)?[fFdD]?/, 'number.float'],
        [/0[xX][0-9a-fA-F_]*[0-9a-fA-F][Ll]?/, 'number.hex'],
        [/0[0-7_]*[0-7][Ll]?/, 'number.octal'],
        [/0[bB][0-1_]*[0-1][Ll]?/, 'number.binary'],
        [/\d+[lL]?/, 'number'],

        // delimiter: after number because of .\d floats
        [/[;,.]/, 'delimiter'],

        // strings
        [/"([^"\\]|\\.)*$/, 'string.invalid'], // non-teminated string
        [/'([^'\\]|\\.)*$/, 'string.invalid'], // non-teminated string
        [/"/, 'string', '@doubleQuote'],
        [/'/, 'string', '@singleQuote'],

        // characters
        [/'[^\\']'/, 'string'],
        [/(')(@escapes)(')/, ['string', 'string.escape', 'string']],
        [/'/, 'string.invalid'],
      ],

      whitespace: [
        [/[ \t\r\n]+/, 'white'],
        [/{%+{[~\-]?/, 'brackets', '@comment1'],
        [/##/, 'comment', '@comment2'],
        [/#/, { token: 'comment', next: '@comment3' }],
      ],

      comment1: [
        [/[~\-]?}%+}/, 'brackets', '@pop'],
        [/[^~\-%}]+/, 'comment'],
        [/[~\-%}]/, 'comment'],
      ],

      comment2: [
        [/##/, 'comment', '@pop'],
        [/[^#]+/, 'comment'],
        [/#/, 'comment'],
      ],

      comment3: [
        [/[~\-]?}}/, 'brackets', '@popall'],
        [/[^~\-}]+/, 'comment'],
        [/[~\-}]/, 'comment'],
      ],

      singleQuote: [
        [/[^\\']+/, 'string'],
        [/@escapes/, 'string.escape'],
        [/\\./, 'string.escape.invalid'],
        [/'/, 'string', '@pop'],
      ],

      doubleQuote: [
        [/[^\\"]+/, 'string'],
        [/@escapes/, 'string.escape'],
        [/\\./, 'string.escape.invalid'],
        [/"/, 'string', '@pop'],
      ],
    },
  });

  const keywords = getKeywords();
  const propertyModel = new PropertyChainParser(keywords).parse();
  const suggestionGenerator = new SuggestionGenerator(propertyModel);

  monaco.languages.registerCompletionItemProvider('scriban', {
    triggerCharacters: ['.'],
    provideCompletionItems: (model, position, context) => {
      const suggestions = suggestionGenerator.generateSuggestions(model, position, context);
      return { suggestions };
    },
  });

  // Create Custom Theme
  monaco.editor.defineTheme('scriban-theme', {
    colors: {},
    base: 'vs-dark',
    inherit: true,
    rules: [
      // { token: 'brackets', foreground: '#149690', fontStyle: 'bold' },
      // { token: 'brackets', foreground: '#7138eb', fontStyle: 'bold' },
      { token: 'variable', foreground: '#4b70ad', fontStyle: 'normal' },
      { token: 'nkeyword', foreground: '#ff0000', fontStyle: 'bold' },
    ],
  });

  monaco.editor.setTheme('scriban-theme');
}

export const monacoConfig: NgxMonacoEditorConfig = {
  onMonacoLoad: monacoLoad,
  defaultOptions: {
    stickyScroll: { enabled: false },
  },
};

@Component({
  selector: 'tcs-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class EditorComponent implements OnInit, OnDestroy {
  @Input()
  public code: string;
  @Input()
  public readOnly = false;
  @Output()
  public codeChange = new EventEmitter<string>();

  public editor: any;

  public editorOptions = {
    theme: 'vs-dark',
    language: 'scriban',
    readOnly: 'false',
    minimap: { enabled: false },
  };

  private _onDestroy$ = new Subject();

  constructor() {}

  public ngOnInit() {
    if (this.readOnly === true) {
      this.editorOptions.readOnly = 'true';
    }
  }

  public ngOnDestroy() {
    this._onDestroy$.next(null);
    this._onDestroy$.complete();
  }

  public onCodeChange() {
    this.codeChange.emit(this.code);
  }

  public onEditorInit(editor: monaco.editor.IStandaloneCodeEditor) {
    editor.updateOptions({ bracketPairColorization: { enabled: false } });
  }
}
